module.exports = __webpack_public_path__ + "img/pd-img-face5.27717c47.png";